import React, {PureComponent} from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import AssetsSummary from './components/AssetsSummary/AssetsSummary';
import AnalysisSummary from './components/AnalysisSummary';
import AnalysisTrend from './components/AnalysisTrend';
import HealthAssets from './components/HealthAssets';
import PredictionEvents from './components/PredictionEvents';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { map } from 'lodash';

import { loadCollections } from "../../../redux/actions/collections";
import { loadDashboard} from "../../../redux/actions/dashboard";

class AssetDashboard extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loadingData: true,
        };
    };

    componentDidMount() {
      const {
        language, loadDashboard, loadCollections
      } = this.props;
      loadCollections();
      loadDashboard({language});
    }

    LoadingDashboardData = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> Loading Dashboard Data
        </div>
    );

  facilityChangeHandler = (e, newValue) => {
    const { language, loadDashboard, loadCollections } = this.props;
    if(newValue) {
      loadDashboard({collection_id: newValue._id, language});
    } else {
      loadCollections();
      loadDashboard({language});
    }
  };

  facilitySearchHandler = e => {
    const { loadCollections } = this.props;
    loadCollections({collection_name: e.target.value});
  };

    render() {
        const {t, rtl, dashboard, collections } = this.props;
        const ai_analysis_trends = dashboard.ai_analysis_trends;
        return (
            <Col>
              <Container className="dashboard">
                {dashboard ?
                  <div>
                    <section id="content">
                        <Row className={'dashboard-header'}>
                          <Col md={8}>
                            <h3 className="page-title">{t('dashboard_assets.page_title')}</h3>
                          </Col>
                          <Col  md={4}>
                            <Autocomplete
                              options={collections}
                              getOptionLabel={option => option.collection_name}
                              style={{ width: 300 }}
                              onChange={this.facilityChangeHandler}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  label={t('dashboard_assets.facility')}
                                  variant="outlined" fullWidth
                                  onChange={this.facilitySearchHandler}
                                />
                              )}
                            />

                          </Col>
                        </Row>
                        <div className="row row-eq-height field">
                          <AssetsSummary assetSummaryData={dashboard.asset_summary} dir={rtl.direction} />
                          <AnalysisSummary summaryData={dashboard.ai_analysis_summary} />
                        </div>
                        <Row className="row-eq-height field graph">
                          {Object.keys(ai_analysis_trends).map((val, key)=>(
                              <Col lg={3} xs={12} sm={3} className="text-center">
                                <AnalysisTrend title={val} data={ai_analysis_trends[val]} />
                              </Col>
                          ))}
                        </Row>
                        <HealthAssets data={dashboard.asset_components_with_health_issues} />
                        <PredictionEvents data={dashboard.important_events_pending_review } />
                    </section>
                  </div>
                :
                  this.LoadingDashboardData()
                }
              </Container>
            </Col>
        );
    }
}

AssetDashboard.propTypes = {
  t: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
};


function mapStateToProps({
       dashboard,rtl, collections, language,
}) {
    return {
        dashboard,
        rtl,
        collections,
        language,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadCollections,
            loadDashboard
        },
        dispatch
    );
}

export default withTranslation('common') (
    connect(
    mapStateToProps,
    mapDispatchToProps
    )(AssetDashboard)
);
